/**
 * Compact user indicator + sign-out button shown in the BrandHeader.
 * Used on every authenticated page so observers can always switch accounts.
 */

import { LogOut } from 'lucide-react';
import { useAuth } from '@/lib/auth/AuthContext';

export function UserBadge({ role }: { role?: 'Admin' | 'Observer' }) {
  const { session, signOut } = useAuth();
  if (!session) return null;
  return (
    <div className="flex items-center gap-3">
      <div className="hidden text-right text-xs leading-tight sm:block">
        <div className="font-medium text-foreground">
          {session.name ?? session.email}
        </div>
        {role && <div className="text-muted-foreground">{role}</div>}
      </div>
      <button
        onClick={signOut}
        aria-label="Sign out"
        title={`Sign out (${session.email})`}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition hover:bg-accent hover:text-foreground"
      >
        <LogOut className="h-5 w-5" />
      </button>
    </div>
  );
}
